"use strict";

jQuery( function ($) {

    $( document ).on( 'click', 'a[data-load-more]', function ( event ) {
        event.preventDefault();

        if( !$( '[data-load-more-target]' ).length ) {
            console.warn( 'Load more target not found' );
            return false;
        }

        if ( $( '[data-loading-icon]' ).length ) {
            return false;
        }

        var $button      = $(event.target),
            template     = $button.data( 'template' ),
            loadingtxt   = $button.data( 'loadingtxt' ),
            normaltxt    = $button.text(),
            title        = $button.attr( 'title' ),
            offset       = $button.data( 'offset' ),
            amount       = $button.data( 'amount' ),
            term         = $button.data( 'term' ),
            filterdata   = $button.data( 'filter' ),
            sort_order   = $button.data( 'sort-order' ),
            loading_icon = ' <span data-loading-icon style="display:inline-block;"><i class="fa fa-spinner fa-pulse"></i></span>';

        $button.html( loadingtxt + loading_icon );
        $button.removeClass( 'has-error' );
        $button.addClass( 'is-loading' );

        $.ajax( {
            url      : themevars.ajaxurl,
            data     : {
                action: 'load_more_items',
                template: template,
                post_id: themevars.post_id,
                offset: offset,
                amount: amount,
                title: title,
                sort: sort_order,
                term: term,
                filterdata: filterdata
            },
            type     : 'POST',
            dataType : 'json'
        } ).done( function ( response ) {
            
            $button.text( normaltxt );
            $button.removeClass( 'is-loading' );

            if ( true !== response.success || 0 === response.data.posts_total ) {
                $button.addClass( 'has-error' );
                console.warn( 'No posts found' );
                return;
            }

            $( '[data-load-more-target]' ).append( response.data.posts );

            var newoffset = offset + amount;
            if( typeof $button.data( 'offset' ) !== 'undefined' ) {
                $button.data( 'offset', newoffset );
            }

            if( newoffset >= parseInt( response.data.posts_total ) ) {
                $( '[data-load-more-container]' ).html("");
            }

            var counter = parseInt( response.data.posts_total );

            if( counter > newoffset) {
                counter = newoffset;
            }

            $( '[data-load-more-counter]' ).html(counter);
        });
    });
});